<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="5"
		@click="(e) => { val.page = (e+2); $emit('next_page', val); }"
		:click_fnc="$localStorage.get('user').username.role==3"
		/>
		<previewImage
			imgSize= "92px"
			:error="false" 
			:img="val.value.img" 
			@chengeFile="(e) => { uploadTF('img', e); }" 
			leading="یک عکس مناسب در سایز 150*150 پیکسل اضافه کنید. و حجم آن کمتر از 1 مگابایت باشد. بارگزاری تصویر پروفایل شما الزامی می‌باشد و این تصویر در تمامی صفحات سایت برای همه کاربران نمایش داده خواهد شد."
		/>
		<textareaInput 
			label="متن درباره من"
			placeholder="(نام شما) فارغ التحصیل رشته‌ی .... از دانشگاه ..... هستم. با سابقه‌ی بیش از ... سال تدریس در زمینه‌های..... را دارم همچنین در ارتقاء یادگیری کاربران و ترکیب مهارت‌های تدریس با رویکرد فعّال و مشارکتی توانمند هستم، از سایر ویژگی‌های حیاتی من در تدریس نوآوری، خلاقیت است."
			:value="val.value.about_me"
			@blurinputTxtFunc="(e) => { val.value.about_me = e; p_sav('about_me') }" 
			leading="(نام شما) فارغ التحصیل رشته‌ی .... از دانشگاه ..... هستم. با سابقه‌ی بیش از ... سال تدریس در زمینه‌های..... را دارم همچنین در ارتقاء یادگیری کاربران و ترکیب مهارت‌های تدریس با رویکرد فعّال و مشارکتی توانمند هستم، از سایر ویژگی‌های حیاتی من در تدریس نوآوری، خلاقیت است."
		/>
		<div class="w-100 overflow-hidden mt-3">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">				
				<file_cloud 
					accept="video/mp4"
					label="ویدئو (اختیاری)"
					:error="false"
					:files="val.value.video"
					@chengeFile="(e) => { uploadTF('video', e);  }"
					@removeFile="(e) => { val.value.video = e;  p_sav('video'); }"
					v-if="val.value.video.length==0"
					leading="یک ویدیو معرفی درباره ی خود ضبط کرده. این ویدیو برای معرفی بیشتر شما در سایت نمایش داده خواهد شد و کاربران آنرا در صفحه اختصاصی شما مشاهده کرده و ترغیب به برگزاری کلاس با شما می شوند. این ویدئو در شبکه اجتماعی استاد بین نیز با نام خودتان منتشر خواهد شد."
				/>
				<div v-else>
					<video 
					class="w-100 border-15"
					controls
					>
					<source 
					:src="imgurl + val.value.video[0].fileUpload" 
					type="video/mp4"
					>
				</video>
				<img
					class="pointer"
					:src="require('../../assets/img/x.svg')"
					width="30"
					style="position: absolute; top: 10px; right: 10px;"
					@click="(e) => { val.value.video = [];  p_sav('video'); }"
				/>
			</div>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
				:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
				<file_cloud 
					label="بارگزاری تصاویر (اختیاری)"
					:error="false"
					:files="val.value.image_teacher"
					@chengeFile="(e) => { uploadTF('image_teacher', e);  }"
					@removeFile="(e) => { val.value.image_teacher = e;  p_sav('image_teacher'); }"
					leading="تصاویری از خود در فضای آموزشی برای مشاهده کاربران قرار دهید. این تصاویر برای معرفی بیشتر شما در سایت نمایش داده خواهد شد و کاربران آنرا در صفحه اختصاصی شما مشاهده کرده و ترغیب به برگزاری کلاس با شما می شوند. این تصاویر جهت تبلیغ برای شما در شبکه اجتماعی استاد بین نیز با نام خودتان منتشر خواهد شد."
				/>
			</div>
		</div>
		<btn text='ثبت نهایی'
			class="pt-3 w-100" 
			textClass="w-100" 
			@clickMe="setPage();"
		/>
		<span v-if="$localStorage.get('user').username">
			<btn 
				type="danger"
				class="pt-3 w-100" 
				textClass="w-100" 
				text="ارسال پیامک"
				@clickMe="send_sms();"
				v-if="$localStorage.get('user').username.role=='3' && ($localStorage.get('user').username.access_level=='0' || $localStorage.get('user').username.access_level=='3')"
			/>
		</span>
		<p v-if="SMS" class="border border-15 p-3 mt-3">
			<b class="text-orange">
				آخرین پیام پشتیبانی:
				<span class="text-gray" style="font-size: 10px;">{{ SMS.date }}</span>
			</b>
			<span class="text-justify text-14"> 
				{{ SMS.text }}
			</span>
		</p>
	</div>
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
	import previewImage from "../../UI/uploadFile/previewImage.vue";
	import textareaInput from "../../UI/input/textareaInput.vue";
	import file_cloud from "../../UI/uploadFile/file_cloud.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";

	export default {
		name: 'teaching_information',
		data(){
			return {
				success_sm: success_sm,
				error: error,
				success: success,
				loading: loading,
				imgurl: window.imgurl,
				SMS: null,
			}
		},
		components: {
			btn,
			textareaInput,
			previewImage,
			multi_step_progress,
			file_cloud,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){
			this.get_sms();
			this.get_sms();
		},
		methods:{
			//********************************************** */
get_sms(THIS=this){
	window.$.post(window.baseurl + 'teachers/get_SMS', {
		token: THIS.$localStorage.get('user'), 
		id: (THIS.chechRole()) ? this.$localStorage.get("s_id_t") : this.$route.params.id,
		page: 5
	}, function (D) {
		THIS.SMS = D.data
	}, "json");
},
// *********************************************************************
chechRole(){
	let user = this.$localStorage.get('user');
	if(user == null){
		return true;
	}else if(user.username.role != 3){
		return true;
	}else{
		return false;
	}
},
//********************************************** */
	send_sms(THIS=this){
		this.$swal.fire({
			position: 'center',
			type: '',
			title: "ارسال پیامک",
			input: "textarea",
			allowOutsideClick: false,
			showCloseButton: true,
			showConfirmButton: true,
			confirmButtonText: "ارسال",
			confirmButtonClass:"btn btn-outline-success border w-50",
			showCancelButton: true,
			cancelButtonText: "بستن",
			cancelButtonClass:"btn btn-danger w-50",
		}).then((result) => {
			if (result.value) {
				THIS.send_smsF(result.value);
			}			
		})
	},
	//********************************************** */
	send_smsF(text, THIS=this){
		window.$.post(window.baseurl + 'teachers/SMS', {
			token: THIS.$localStorage.get('user'), 
			val : this.val, 
			text: text,
			page: 5
		}, function (D) {
			THIS.success(THIS, 'ارسال شد')
			THIS.get_sms();
	}, "json");
},
		uploadTF(val, e, THIS = this) {
			if(val && e) {
				THIS.loading(THIS);
			}
			var format =  ["jpg", "jpeg", "png", "pdf"];
			var idImg =  "t_[DATE]_[RANDOM]";
			if(val == "img"){
				format = ["jpg", "jpeg", "png"];
				idImg = "t_"+this.val.value.id;
			}
			if(val == "video"){
				format = ["mp4"];
			}
			var formData = new FormData();
			formData.append("file", e);
			formData.append("format",format);
			formData.append("idImg", idImg);
			var xhttp = new XMLHttpRequest();
			xhttp.open("POST", window.upldurl, true);
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					this.getVar = JSON.parse(this.responseText);
					if (this.getVar.response == 1) {
						let F = {
							fileName: this.getVar.filename,
							fileUpload: this.getVar.uploadFileName,
						};
						if(val != "img"){
							THIS.val.value[val].push(F);
							THIS.p_sav(val);
						}else{
							THIS.val.value.img = F.fileUpload;
						}
						THIS.success_sm(THIS);
					} else {
						THIS.error(THIS, "فرمت فایل باید "+format[0]+" باشد");
					}
				}
			};
			xhttp.send(formData);
		},
//********************************************************** */
setPage(){
	if(this.val.value.img=="" || this.val.value.img==null){
		this.error(this, "عکس مدرس آپلود نشده است");
	}else if( this.val.value.about_me=='' || this.val.value.about_me==null) {
		this.error(this);
	}else{
		this.val.page = 8;
		if(this.chechRole()){
			this.val.value.status = 10;
			this.p_sav('status');
		}
		this.$emit('next_page', this.val);
	}
},
//********************************************************** */
p_sav(fild) {
	let f = (fild == "category") ? 'cats' : fild;
	let v = this.val.value[fild];
	if(this.val.value[fild] == true){
		v = 1;
	} else if(this.val.value[fild] == false){
		v = 0;
	}
	this.val.id = (this.val.id) ? this.val.id : this.val.value.id;
	if(this.$localStorage.get('user')) {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id, admin: this.$localStorage.get('user')}, function () {}, "json");
	} else {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id}, function () {}, "json");
	}

},			
//********************************************** */
chechRole(){
	let user = this.$localStorage.get('user');
	if(user == null){
		return true;
	}else if(user.username.role != 3){
		return true;
	}else{
		return false;
	}
},
//********************************************** */
		}
	}
</script>
<style>

</style>
